import React from "react";
import { Grid, Typography, Box, Link } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import MailIcon from "@mui/icons-material/Mail";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Element } from "react-scroll";

const ContactDetails = () => {
  const location = { lat: 28.574596723371293, lng: 77.31355658540548 }; //random
  return (
    <Element name="contact">
      <Box
        sx={{
          background: "#191919",
          color: "#a6b1b7",
          py: 3,
          px: { xs: 2, sm: 4, md: 10, lg: 15 },
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            alignItems: "center",
            flexDirection: { xs: "row" },
            textAlign: { xs: "center" },
            justifyContent: { xs: "center" },
          }}
        >
          {/* Phone Section */}
          <Grid
            item
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              justifyContent: "center",
            }}
            xs={12}
          >
            <PhoneIcon />
            <Typography>
              <Link
                href="tel:+919236548885"
                underline="none"
                color="inherit"
                sx={{
                  "&:hover": { color: "#fff" },
                }}
              >
                +91 92365 48885
              </Link>
            </Typography>
          </Grid>

          {/* Email Section */}
          <Grid
            item
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              justifyContent: "center",
            }}
            xs={12}
          >
            <MailIcon />
            <Typography>
              <Link
                href={`https://www.google.com/maps?q=${location.lat},${location.lng}`}
                underline="none"
                color="inherit"
                sx={{
                  "&:hover": { color: "#fff" },
                }}
              >
                sales@kernit-innovations.com
              </Link>
            </Typography>
          </Grid>
          {/* Address Section */}
          <Grid
            item
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              justifyContent: "center",
            }}
            xs={12}
          >
            <LocationOnIcon />
            <Typography>
              <Link
                href={`https://www.google.com/maps?q=${location.lat},${location.lng}`}
                underline="none"
                color="inherit"
                sx={{
                  "&:hover": { color: "#fff" },
                }}
              >
                C-001/A2, Sector 16B, Gautam Buddha Nagar Noida, UP, Floor 19,
                Noida, Uttar Pradesh 201301
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Element>
  );
};

export default ContactDetails;
